import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Group from "@midland-industries/Components/Group";
import React from "react";
import styled from "styled-components";

const enum fields {
    speed = "speed",
    images = "images",
}

interface ImageModel {
    fields: {
        imageTitle: string;
        image: string;
    };
}

interface ScrollingBannerProps extends WidgetProps {
    fields: {
        [fields.speed]: number;
        [fields.images]: ImageModel[];
    };
}

const Images = styled.div`
    display: flex;

    @keyframes swipe {
        0% {
            transform: translateX(0);
        }

        100% {
            transform: translateX(-100%);
        }
    }
`;

const ImageSection: React.FC<ScrollingBannerProps> = ({ fields: { speed, images } }) => {
    return (
        <Images style={{ animation: `swipe ${speed}s linear infinite` }}>
            {images.map(({ fields: { image, imageTitle } }, index) => (
                <div key={`${imageTitle}-${index}`} style={{ padding: "0 30px" }}>
                    <img src={image} alt={imageTitle} />
                </div>
            ))}
        </Images>
    );
};

const ScrollingBanner: React.FC<ScrollingBannerProps> = props => {
    return (
        <div style={{ overflow: "hidden", width: "100%" }}>
            <Group>
                <ImageSection {...props} />
                <ImageSection {...props} />
            </Group>
        </div>
    );
};

const scrollingBanner: WidgetModule = {
    component: ScrollingBanner,
    definition: {
        displayName: "Scrolling Banner",
        group: "Basic",
        icon: "presentation-screen",
        fieldDefinitions: [
            {
                name: "speed",
                editorTemplate: "IntegerField",
                defaultValue: 10,
                fieldType: "General",
                min: 1,
            },
            {
                name: "images",
                editorTemplate: "ListField",
                getDisplay: ({ fields: { imageTitle } }) => imageTitle || "Image",
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "imageTitle",
                        editorTemplate: "TextField",
                        defaultValue: "Image",
                    },
                    {
                        name: "image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default scrollingBanner;
